<script setup></script>

<template>
  <main class="main-content mt-0 ps">
    <div
      class="page-header min-vh-100"
      style="background-image: url('../../../assets/img/illustrations/404.svg')"
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-7 mx-auto text-center">
            <h1 class="display-1 text-bolder text-primary">:( Error 404</h1>
            <h2>Página no encontrada</h2>
            <p class="lead text-sm pt-3">
              La URL a la cual deseas acceder no ha encontrado alguna
              referencia. Verifica e intenta de nuevo. Si el problema persiste
              comunícate con tu administrador de sistema.
            </p>
            <router-link
              :to="{ name: 'cotizacion-rapida' }"
              type="button"
              class="btn bg-gradient-dark mt-4"
            >
              Ir a inicio
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="ps__rail-x" style="left: 0px; bottom: 0px">
      <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px"></div>
    </div>
    <div class="ps__rail-y" style="top: 0px; right: 0px">
      <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px"></div>
    </div>
  </main>
</template>

<style scoped>
main {
  background-color: #ffffff;
  opacity: 1;
  background-image: radial-gradient(
    ellipse farthest-corner at 10px 10px,
    #f1f1f1,
    #f1f1f1 50%,
    #ffffff 50%
  );
  background-size: 10px 10px;
}
</style>
